import axios from 'axios'

import { IMcpSession } from './lucaMcp'

const SUPPORT_AGENT_ORIGIN = import.meta.env.VITE_SUPPORT_AGENT_API_ORIGIN

export const LUCA_WORKFLOW_TOOLS_STALE_MS = 6 * 60 * 60 * 1000
export const MAX_LUCA_APPROVED_TOOLS = 64
export const lucaWorkflowToolsQueryKey = (businessSlug?: string) =>
  [businessSlug, 'luca-workflow-tools'] as const

export interface ILucaWorkflowTool {
  name: string
  title: string
  category: string
  description: string
  read_only: boolean | null
}

export interface ILucaWorkflowToolCatalog {
  tools: ILucaWorkflowTool[]
  total_tool_count: number
  cached: boolean
}

const client = axios.create({ baseURL: SUPPORT_AGENT_ORIGIN })

export const fetchLucaWorkflowTools = async (
  session: IMcpSession,
  businessSlug: string
): Promise<ILucaWorkflowToolCatalog> => {
  const { data } = await client.get<ILucaWorkflowToolCatalog>('/v1/workflow/tools', {
    headers: {
      Authorization: `Bearer ${session.token ?? ''}`,
      'X-Origin': (session.country || 'FI').toUpperCase()
    },
    params: { business_slug: businessSlug }
  })
  return data
}
